import React from 'react';
import { useSearchParams } from 'react-router-dom';
import { InventoryIntakePanel } from '../components/inventory/InventoryIntakePanel';
import { InventorySectionNav } from '../components/inventory/InventorySectionNav';
import { isInventoryLookupGame } from '../lib/inventoryNav';
import { colors, spacing, typography, typographyFlat } from '../styles/tokens';

export const InventoryAddPage: React.FC = () => {
  const [searchParams] = useSearchParams();
  const requestedGame = searchParams.get('game') ?? undefined;
  const initialGame = isInventoryLookupGame(requestedGame) ? requestedGame : 'mtg';

  return (
      <div style={styles.container}>
        <div style={styles.header}>
          <h1 style={styles.title}>Add Inventory</h1>
          <p style={styles.subtitle}>Scan or search cards, tokens, and art cards, then submit your batch.</p>
          <InventorySectionNav />
        </div>

        <InventoryIntakePanel initialGame={initialGame} />
      </div>
  );
};

const styles = {
  container: {
    padding: spacing.xl,
  },
  header: {
    marginBottom: spacing.lg,
  },
  title: {
    margin: 0,
    fontSize: typography.h1.fontSize,
    fontWeight: typography.h1.fontWeight,
    color: colors.text,
  },
  subtitle: {
    margin: `${spacing.sm} 0 0`,
    fontSize: typographyFlat.fontSize.lg,
    color: colors.textSecondary,
  },
};

export default InventoryAddPage;
